export default __webpack_public_path__ + "static/media/warning.2929f06d.png";